// NCP-5516: whether the customer is part-way through editing an application
// they had already submitted — the journey that starts with "Edit" on the quote
// page.
//
// The edit spans several routes (Phase 2, then one Phase 3 survey per LOB) and
// the customer may refresh on any of them, so this cannot live in router state
// or component state. sessionStorage is the narrowest store that survives both:
// scoped to the tab, gone when it closes.
//
// Nothing about the underwriting route distinguishes an edit from a first
// application — both land on /:applicationGroupId — so the flag is set at the
// one place that knows, the quote page's Edit button.
const APPLICATION_EDIT_KEY = 'applicationEditInProgress';

/**
 * Shown for the whole edit, on Phase 2 and on every Phase 3 LOB survey. There
 * is no dismiss control: the statement stays true until the walk is finished,
 * and a customer who closed it would be the one who most needs it.
 */
export const RESUBMIT_TO_SAVE_MESSAGE =
  'Please note: The application must be completed and resubmitted for any and all changes to be saved.';

/** Called by the quote page's Edit button, before it navigates. */
export const markApplicationEditStarted = (): void => {
  sessionStorage.setItem(APPLICATION_EDIT_KEY, 'true');
};

export const isApplicationEditInProgress = (): boolean =>
  sessionStorage.getItem(APPLICATION_EDIT_KEY) === 'true';

/**
 * Called when the walk ends — completed or declined — and when a brand new
 * application starts in the same tab, so a stale flag can never put the banner
 * in front of someone applying for the first time.
 */
export const clearApplicationEdit = (): void => {
  sessionStorage.removeItem(APPLICATION_EDIT_KEY);
};
